<div class="card card-custom"
	[ngClass]="{ 'card-body-progress card-body-progress-overlay' : viewLoading }">
	<div class="card-header">
		<div class="card-title">
			<h3 class="card-label">Details</h3>
		</div>
	</div>

	<div class="card-body">

		<table class="table table-striped">    
			<tbody><tr>
				<th class="border0">Name</th>
				<td class="border0">{{phoneCall.name}}</td>
				<th class="border0">Phone</th>
				<td class="border0">{{phoneCall.contact}}</td>
			</tr>
			<tr>
				<th>Date</th>
				<td>{{phoneCall.date | date:'dd-MM-yyyy'}}</td>
				<th>Next Follow Up Date</th>
				<td>{{phoneCall.followUpDate | date:'dd-MM-yyyy'}}</td>
			</tr>
			<tr>
				<th>Call Duration</th>
				<td>{{phoneCall.callDureation}}</td>
				<th>Call Type</th>
				<td>{{phoneCall.callType}}</td>
			</tr>
			<tr>
				<th>Description</th>
				<td>{{phoneCall.description}}</td>
				<th>Note</th>
				<td>{{phoneCall.note}}</td>
			</tr>
		</tbody></table>
		
	</div>
	<div class="card-footer">
			
	</div>

	
</div>
